export const CHECKBOX = 'CHECKBOX';
export const STARS = 'INDEXED';
